module.exports = __webpack_public_path__ + "img/placemakers-underconstruction-home.58261ea9.webp";